var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Multiselect',_vm._b({attrs:{"options":_vm.suppliers,"custom-label":function (ref) {
	var id = ref.id;
	var legal_name = ref.legal_name;

	return ("" + legal_name);
},"track-by":"id","placeholder":_vm.$attrs.placeholder || 'Select a Supplier'},on:{"input":_vm.onSelected,"close":function($event){return _vm.$emit('blur')}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},'Multiselect',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }